export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const FILE_BASE_URL = import.meta.env.VITE_FILE_BASE_URL;

console.log("API_BASE_URL:", API_BASE_URL);
console.log("FILE_BASE_URL:", FILE_BASE_URL);
